import React from 'react';
import WorkCarousel from '../../components/WorkCarousel/WorkCarousel';
import { useRandomWorks } from '../../hooks/useRandomWorks';
import './OurWorks.css';

const RANDOM_WORKS_COUNT = 6;

const OurWorks = () => {
  const { items: workItems, isLoading } = useRandomWorks(RANDOM_WORKS_COUNT);

  return (
    <section className="our-works">
      <div className="our-works__gradient-wrap">
        <div className="our-works__hero">
          <div className="our-works__inner">
            <p className="our-works__eyebrow">Портфолио студии</p>
            <h1 className="our-works__title">Наши работы</h1>
            <p className="our-works__description">
              Сравнивайте результат на слайдере до/после и смотрите, какую услугу мы выполняли на
              каждом автомобиле.
            </p>
          </div>
        </div>

        <WorkCarousel title="" items={workItems} isLoading={isLoading} />
      </div>
    </section>
  );
};

export default OurWorks;
